import { createAction, union } from '@ngrx/store';
import { auth } from 'firebase/app';
import { PhoneNumber } from 'src/app/models/auth/phone-number';

export const storeConfirmationResult = createAction(
  'SignInActions storeConfirmationResult',
  (payload: auth.ConfirmationResult) => ({ payload }),
);

export const storePhoneNumber = createAction(
  'SignInActions storePhoneNumber',
  (payload: PhoneNumber) => ({ payload }),
);

export const showNoProfileAlert = createAction(
  'SignInActions showNoProfileAlert',
);

export const updateLoading = createAction(
  'SignInActions updateLoading',
  (payload: boolean) => ({ payload }),
);

export const storeErrorMessage = createAction(
  'SignInActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const resetState = createAction('SignInActions resetState');

const all = union({
  storeConfirmationResult,
  storePhoneNumber,
  showNoProfileAlert,
  updateLoading,
  storeErrorMessage,
  resetState,
});
export type SignInActionsUnion = typeof all;
